module.exports = __webpack_public_path__ + "static/img/relationNew2.7383eb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/relation/relationNew2.jpg
// module id = YNW+
// module chunks = 0